<template>
  <div class="animated fadeIn">
    <b-tabs
      active-nav-item-class="font-weight-bold text-uppercase text-danger">
      <b-tab title="Admin Information">
        <b-card border-variant="primary">
          <div slot="header">
            <strong>Admin Information</strong>
            <span class="pull-right" v-if="!add && model.created_at">Joined_at  : {{model.created_at | datetime}}</span>
          </div>
          <b-row>
            <b-col md="4">
              <b-form-group label="Allow login" label-for="ph_use"
                v-b-tooltip.hover title="Allow login.">
                <c-switch color="info" label size="sm" v-model="model.is_alive" :disabled="lock" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label>Permissions</label>
                <label for="ph_group" v-b-tooltip.hover title="Permission."></label>
                <v-select v-if="!lock" label="text" v-model="model.permissions" :options="codes.permissions_admin"></v-select>
                <b-form-input type="text" v-if="lock" :value="model.permissions" plaintext></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4" v-if="model.id">
              <b-form-group>
                <label>Last_visit</label>
                <p>
                  {{model.last_visit | datetime}} @ {{model.last_addr}}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_username" v-b-tooltip.hover title="Username">Username(ID) (*)
                  <span v-if="model.is_del" class="text-danger">Deleted user, Logging in is not possible even if you allow it.</span>
                </label>
                <b-form-input :disabled="!add || lock" type="text" id="ph_username" v-model="model.username" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- {{model}} -->
          <!-- <password :badge="true" v-model="model.new_password" :strengthMeterOnly="false" :toggle="false" @score="showScore" @feedback="showFeedback" /> -->
          <b-row v-show="add || !lock">
            <b-col md="6">
              <b-form-group>
                <label for="ph_pass">{{add ? 'User' : 'Change'}} Password(*)</label>
                <b-form-input type="password" id="ph_pass" v-model="model.new_password" :plaintext="lock"></b-form-input>
                <b-badge v-if="model.new_password"  :variant="password_policy('number') ? 'success' : 'danger'"> Number </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('uppercase') ? 'success' : 'danger'"> Upper Characters </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('lowercase') ? 'success' : 'danger'"> Lower Characters </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('spacial') ? 'success' : 'danger'"> Special Characters </b-badge>
                <b-badge v-if="model.new_password"  :variant="password_policy('length') ? 'success' : 'danger'">
                  Min Length : 10
                </b-badge>
              </b-form-group>
            </b-col>
            <b-col md="6" v-if="model.new_password">
              <b-form-group>
                <label for="ph_pass2">Password Repeat(*)</label>
                <b-form-input type="password" id="ph_pass2" v-model="model.new_password_repeat" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_nickname">Nick Name(*)</label>
                <b-form-input type="text" id="ph_nickname" v-model="model.nickname" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_group" v-b-tooltip.hover title="Enter a single IP or network range, etc) 192.168.0.100, 192.168.0.0/24 ">Allowed IP</label>
                <b-form-textarea ref="allow_ip_list" :rows="model && model.allow_ip ? model.allow_ip.length + 2 : 0" max-rows="10" v-model="model.allow_ip_list" :plaintext="lock">
                </b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <h4>Region</h4>
          <hr>
          <b-row>
            <b-col md="6">
              <b-form-group>
                <label for="ph_country_group" v-b-tooltip.hover title="country">Country(*)</label>
                <v-select :readonly="true" :disabled="lock" label="name" v-model="region.country" :options="codes.country" ></v-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <label for="ph_language_group" v-b-tooltip.hover title="language">language(*)</label>
                <v-select :readonly="true" :disabled="lock" label="name" v-model="region.language" :options="codes.language"></v-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group>
                <label for="ph_timezone_group" v-b-tooltip.hover title="Timezone">Timezone(*)</label>
                <v-select :readonly="true" :disabled="lock" label="name" v-model="region.timezone" :options="codes.timezone" ></v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>
      </b-tab>
      <b-tab title="Admin Login Log" :disabled="!model.id" @click="() => this.$refs._login_list && this.$refs._login_list.refresh()">
        <log-Login-List v-if="model.id" :user="model" ref="_login_list"></log-Login-List>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>

const default_model = () => (
  { is_alive : true, permissions : 'Owner' }
);


import codes from '@/codes';
import { Api } from '@/service';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import * as forge from 'node-forge'
import * as _ from 'lodash';
import reg from '@/reg';

// another vue
import logLoginList from '../../Log/login/Login.List.Admin'
import logActionList from '../../Log/action/Action.List.Admin'

export default {
  props: ['admin_id'],
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  components: {
    cSwitch,
    vSelect,
    logLoginList,
    logActionList
  },
  data : () => ({
      codes,
      confirm: false,
      add: false,
      lock: true,
      group_list: undefined,
      model : default_model(),
      allowed: false,
      region : {
        language : codes.language_default,
        country : codes.country_default,
        timezone : codes.timezone_default
      },
      password_meter : { is_spacial : false, is_alphabat_upper : false, is_alphabat_lower : false, is_number : false, check_length : false  },
  }),
  computed: {
    // profile() { return auth.profile; }
  },
  methods: {
    async get() {
      this.model = default_model()

      console.log('admin.detail.vue', 'load item', this.admin_id);
      if(!this.admin_id) { return this.$toastr.e('incorrect target partner') }

      try{
        this.add = false;
        this.lock = true

        let rs = await Api.Manager_Call('admin', 'detail', { id : this.admin_id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)

        let is_done_country = false;
        codes.country.forEach(r => { if(is_done_country) { return; } else if(this.model.country && r.value == this.model.country.toUpperCase()) { this.region.country = r; is_done_country = true } });

        let is_done_language = false;
        codes.language.forEach(r => { if(is_done_language) { return; } else if(this.model.language && r.value == this.model.language.toUpperCase()) { this.region.language = r; is_done_language = true } });

        let is_done_timezone = false;
        codes.timezone.forEach(r => { if(is_done_timezone) { return; } else if(this.model.timezone && r.value == this.model.timezone) { this.region.timezone = r; is_done_timezone = true } });

        this.model.allow_ip_list = this.model.allow_ip && this.model.allow_ip.join("\n")

      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list() }
    }
  },
  created() { console.log('admin_Detail.vue', 'created'); },
  destroyed() { console.log('admin_Detail.vue', 'destroyed'); },
  mounted() {
    console.log('admin_Detail.vue', 'mounted');
    this.get();
  },
}
</script>
